
<app-header ></app-header>
<div class="container">
    <div class="centered text-center">
        <h3> Récords</h3>
    </div>
</div>

<div class="container">

<div class="row"> 
    <div class="row"><div class="col-md-12"><b> Fechas de consulta:</b> </div></div>
   <div class="container row">
        
       <form #theForm ="ngForm"  class="form-inline" autocomplete="false">
           <div class="form-group">
               <div class="dx-field-label"> Fecha Inicio: </div>
               <div class="dx-field-value">
                <dx-date-box [value]="startDate" type="date"
                             displayFormat="d/MM/yyyy"
                             [width]="170"
                             name="startDate"   [(ngModel)]="startDate" ></dx-date-box>
               </div>
           </div>
           <div class="form-group">
                <div class="dx-field-label">  <span> Fecha fin:</span> </div>
                <div class="dx-field-value">
                 <dx-date-box [value]="endDate" type="date"
                              displayFormat="d/MM/yyyy"
                              [width]="170"
                              name="endDate"   [(ngModel)]="endDate" ></dx-date-box>
                </div>
            </div>

            <div class="btn-group btn-group-toggle" data-toggle="buttons">
                 <div class="col-md-4">
                        <button type="submit"  class="btn btn-info"  (click)="onAttLogSend()" [disabled]="theForm.invalid" >
                                Consultar 
                           </button> 
                 </div>
            </div> 
       </form>
   </div>
    <dx-data-grid id="idgrid" class="table table-hover"
                  [dataSource]="dataSource"
                  [showBorders]="true"
                  [remoteOperations]="true" >
                             <!-- [showColumnHeaders]="false" -->
        <dxo-paging [pageSize]="15"></dxo-paging>
        <dxo-selection
        [selectAllMode]="allMode"
        [showCheckBoxesMode]="checkBoxesMode" mode="multiple" ></dxo-selection>

        <dxo-pager [showPageSizeSelector]="10"
                    [allowedPageSizes]="[15,20,25,30,35,40]"
                    [showInfo]="true" ></dxo-pager>
        <dxo-export [enabled]="true" fileName="Récords"  [allowExportSelectedData]="true"></dxo-export>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <!--dxo-filter-row [visible]="true" [applyFilter]="currentFilter"></dxo-filter-row-->
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxi-column dataField="userPin" caption="Usuario" [width]="150">
        <!--dxi-column dataField="userPin" caption="Usuario" [width]="150" [editorOptions]="{ disabled: editorOptions }"-->
        </dxi-column>
        <dxi-column dataField="deviceName" caption="Dispositivo"   [width]="240"></dxi-column>
        <dxi-column dataField="verifyTime" dateType="date" caption="Récord" ></dxi-column>
    
    </dx-data-grid> 
</div>  
</div>



<app-footer></app-footer>